import queryString, { ParsedQuery } from 'query-string';
import { ContentType } from '../client';

const prepareRequestData = <T extends ParsedQuery>(
  data: T,
  contentType: ContentType
): T | string => {
  if (
    contentType === ContentType.JSON ||
    contentType === ContentType.MULTIPART_FORM_DATA
  ) {
    return data;
  }
  return queryString.stringify(data);
};

export default prepareRequestData;
